<template>
  <div
    class="d-flex justify-content-center position-fixed"
    style="left:50%;top:50%;margin:-10px -150px;width:300px;z-index:9999999999">
    <div class="spinner-grow text-primary spinner-grow-sm mx-2" role="status">
      <span class="sr-only">.</span>
    </div>
    <div class="spinner-grow text-secondary spinner-grow-sm mx-2" role="status">
      <span class="sr-only">.</span>
    </div>
    <div class="spinner-grow text-primary spinner-grow-sm mx-2" role="status">
      <span class="sr-only">.</span>
    </div>
    <div class="spinner-grow text-secondary spinner-grow-sm mx-2" role="status">
      <span class="sr-only">.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>
